module.exports = __webpack_public_path__ + "static/media/polanco.96ff3289.webp";